import { Injectable } from '@angular/core';
import { AbstractDialogService, DialogOptions } from '@examdojo/core/dialog';
import { MarkCalculationMethod } from '@examdojo/models/markscheme-v2';
import { QuestionEditorState } from '@examdojo/models/question-editor';
import { QuestionPickerDialogComponent } from './question-picker-dialog.component';
import { QuestionPickerResult } from './question-picker.model';

export const QUESTION_PICKER_DIALOG_SERVICE = 'question-picker-dialog';

@Injectable({
  providedIn: 'root',
})
export class QuestionPickerDialogService extends AbstractDialogService<
  QuestionPickerDialogInput,
  QuestionPickerResult,
  typeof QuestionPickerDialogComponent
> {
  readonly id = QUESTION_PICKER_DIALOG_SERVICE;
  protected override readonly component = QuestionPickerDialogComponent;

  override options: DialogOptions = {
    cssClass: 'fullscreen action-sheet-on-mobile',
    backdropDismiss: false,
    handle: false,
  };

  override openDialog({ input: data, options }: { input: QuestionPickerDialogInput; options?: DialogOptions }) {
    return super.openDialog({
      options: {
        ...options,
        componentProps: {
          cachedQuestionState: data?.cachedQuestionState,
          newQuestionState: data?.newQuestionState,
          markCalculationMethod: data?.markCalculationMethod,
        },
      },
    });
  }
}

interface QuestionPickerDialogInput {
  cachedQuestionState: QuestionEditorState;
  newQuestionState: QuestionEditorState;
  markCalculationMethod: MarkCalculationMethod;
}
